import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';

const initialState = {
  refreshToken: false,
};

export default function reduceAuth(state = initialState, action) {
  if (!action.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);
  const data = action?.response;

  switch (action.type) {
  case ActionTypes.auth.checkIfLoggedIn.START:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}), // Keep the state in case we are just refetching
          fetching: true,
          error: null,
        },
      },
    };
  case ActionTypes.auth.checkIfLoggedIn.SUCCESS:
    return {
      ...state,
      ...{
        [actionGroup]: {
          isLoggedIn: data?.isLoggedIn,
          success: true,
          fetching: false,
          error: null,
          companyGroups: data?.companyGroups || [],
          isAdmin: data?.isAdmin,
        },
      },
    };
  case ActionTypes.auth.checkIfAdmin.SUCCESS:
    return {
      ...state,
      isAdmin: true,
    };
  case ActionTypes.auth.checkIfAdmin.ERROR:
    return {
      ...state,
      isAdmin: false,
    };
  case ActionTypes.auth.signUp.START:
  case ActionTypes.auth.verifyAccount.START:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: true,
          error: null,
          success: false,
        },
      },
    };
  case ActionTypes.auth.signUp.SUCCESS:
  case ActionTypes.auth.verifyAccount.SUCCESS:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: false,
          error: null,
          success: true,
        },
      },
    };
  case ActionTypes.auth.signUp.ERROR:
  case ActionTypes.auth.verifyAccount.ERROR:
    return {
      ...state,
      ...{
        [actionGroup]: {
          fetching: false,
          success: false,
          error: data?.error,
        },
      },
    };
  case ActionTypes.auth.checkIfLoggedIn.ERROR:
    return {
      ...state,
      ...{
        [actionGroup]: {
          fetching: false,
          success: false,
          error: data.error,
          companyGroups: [],
        },
      },
    };

  case ActionTypes.auth.refreshToken:
    return {
      ...state,
      refreshToken: action?.refreshToken,
      CHECK_STATUS_API: {
        ...state?.CHECK_STATUS_API,
        companyGroups: action?.companyGroups || [],
      },
    };
  case ActionTypes.auth.clear:
    return initialState;
  case ActionTypes.auth.clearErrors:
    return {
      ...state,
      SIGN_UP_API: { ...state.SIGN_UP_API, error: null },
    };
    // no default
  }
  return state;
}
